import * as jsxRuntime from "/tmp/workspace/Deploy_NewTeacher_FrontEnd_Pipeline_Test/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment